const API_BASE = process.env.REACT_APP_API?.replace('/api', '') || 'http://lac.local'

const getMessage = (data, fallback) => data?.message || data?.error || fallback

async function postAction(path, body = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok || data.success === false) {
    const error = new Error(getMessage(data, `Request failed: ${path}`))
    error.status = response.status
    error.errors = data?.errors || {}
    throw error
  }

  return data
}

export const checkoutApi = {
  getCart: (cartNumber) =>
    postAction('/actions/my-module/cart/get-cart', cartNumber ? { cartNumber } : {}),
  start: (cartNumber) =>
    postAction('/actions/my-module/checkout/start', cartNumber ? { cartNumber } : {}),
  customer: (payload) => postAction('/actions/my-module/checkout/customer', payload),
  shippingMethod: (shippingMethodHandle, cartNumber) =>
    postAction('/actions/my-module/checkout/shipping-method', { shippingMethodHandle, cartNumber }),
  paymentMethod: (paymentMethodHandle, cartNumber) =>
    postAction('/actions/my-module/checkout/payment-method', { paymentMethodHandle, cartNumber }),
  complete: (cartNumber, paymentForm = {}) => postAction('/actions/my-module/checkout/complete', { cartNumber, paymentForm }),
}
